export default "__VITE_ASSET__C870bIan__"